import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { getOfflineActiveStepNumber3, offlineTransferPhaseData3 } from "../../../../utils";
import { TransferPhasebar } from "../../../ui/TransferPhasebar";

export const OfflineTransferPhaseLayout3 = () => {
  const location = useLocation();

  const [activeStepNumber, setActiveStepNumber] = React.useState<number>(1);

  React.useEffect(() => {
    setActiveStepNumber(getOfflineActiveStepNumber3(location.pathname, activeStepNumber));
  }, [location.pathname]);

  return (
    <div className="flex">
      <TransferPhasebar
        transactionMode="Flywire"
        data={offlineTransferPhaseData3}
        activeStepNumber={activeStepNumber}
      />
      <div className="ml-[379px] w-full h-full">
        <Outlet />
      </div>
    </div>
  );
};
